export function shouldHideUnready(isReady: boolean) {
  return !isReady && process.env.HIDE_UNREADY === 'true'
}
